/**
 * Locale-aware date display for the HeyBro Insurance surfaces.
 *
 * The backend stores/emits ISO dates (YYYY-MM-DD); the UI shows them in the
 * user's selected language format (de → 26.08.2026, en → 08/26/2026, …).
 * Values that are not a full ISO date (e.g. "GB 2025", "2026-06") pass
 * through unchanged — better an unformatted date than a wrong one.
 */

const ISO_DATE_RE = /^\d{4}-\d{2}-\d{2}/;

export function formatDate(value, language) {
  if (!value) return '';
  const s = String(value).slice(0, 10);
  if (!ISO_DATE_RE.test(s)) return String(value);
  const [y, m, d] = s.split('-').map(Number);
  try {
    // UTC keeps the calendar day stable regardless of the viewer's timezone.
    return new Date(Date.UTC(y, m - 1, d)).toLocaleDateString(language || 'de', {
      day: '2-digit', month: '2-digit', year: 'numeric', timeZone: 'UTC',
    });
  } catch (e) {
    return s;
  }
}

/** Replace every ISO date INSIDE a text (e.g. "(Abruf 2026-08-26)") with its
 * locale-formatted form. */
export function localizeDatesInText(text, language) {
  return (text || '').replace(/\b\d{4}-\d{2}-\d{2}\b/g, (m) => formatDate(m, language));
}
